/// <reference lib="dom" />
/* eslint-disable no-console */
import { hydrateRoot } from 'react-dom/client';
import { createPage, isPageName } from '../ui/page-components.generated';

(() => {
  const mountPoint = document.querySelector('[data-component-name]');
  if (!mountPoint) {
    console.error('No mount point found.');
    return;
  }

  const componentName = mountPoint.getAttribute('data-component-name');
  if (!componentName) {
    console.error('No component name found.');
    return;
  }

  if (!isPageName(componentName)) {
    console.error(`Component "${componentName}" is not a page component.`);
    return;
  }

  const propsNode = document.querySelector('[data-props]');
  if (!propsNode) {
    console.error('Props node not found.');
    return;
  }

  const props = propsNode.textContent;
  if (!props) {
    console.error('No props present in props node.');
    return;
  }

  let json;
  try {
    json = JSON.parse(props);
  } catch (error) {
    console.error('Prop parsing failed');
    console.error(error);
    return;
  }

  hydrateRoot(mountPoint, createPage([componentName, json]));
  document.documentElement.setAttribute('data-hydrated', '');
})();
